/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
import { Modal } from 'antd';
import { http } from '@4beefopag/4bee-fopag-core/dist/services';
import { moneyFormat } from '@4beefopag/4bee-fopag-core/dist/util';
import { APONTAMENTO } from '../index';
import { parseToLegacyRequest } from '../../util/legacyParse';
import { modalColaboradoresExcedenteValorRemuneracao } from '../../../components/pages/ApontamentoProducao/modals';
import { sendPayroll } from '../../repository/payrollRepository';
import { createMetric } from '../../repository/metricRepository';
import mostrarErro from '../../util/error-handler';

/**
 * Hook para processamento de apontamento
 */
export const useApontamentoProcessing = (
  payroll,
  type,
  parameterization,
  user,
  applySelectionRulesToCollaborators,
  fetchPayroll,
  setLoadingModal,
  setShowProcessModal,
  setSelectedCollaborators
) => {
  const calculateLiquidoTotal = (items) => {
    if (type === APONTAMENTO.tiposRequisicoes.mensal) {
      return items.reduce((prev, item) => prev + (item.liquido || 0), 0.0);
    }
    return items.reduce(
      (prev, item) => prev + (item.adiantamento || 0) + (item.reembolso || 0) + (item.variavel || 0),
      0.0
    );
  };
  const finalizeProcessing = async (request, acceptedExceededCollaborators = false) => {
    const cooperatorsRequest = applySelectionRulesToCollaborators();
    const payload = {
      acceptedExceededCooperators: acceptedExceededCollaborators,
      expectedInvoiceDate: request.expectedInvoiceDate,
      payroll: {
        ...request,
        items: cooperatorsRequest,
        totalLiquido: request.calculatedNetTotal || calculateLiquidoTotal(cooperatorsRequest),
      },
      expectedPaymentDate: request.expectedDate,
    };
    try {
      await sendPayroll(payload);

      Modal.success({
        title: 'Sucesso',
        content: <p>Requisição processada com sucesso!</p>,
      });

      fetchPayroll(request.id, setSelectedCollaborators);
      setLoadingModal(false);
      setShowProcessModal(false);
    } catch (err) {
      if (err.response) {
        const { data } = err.response;
        if (data?.type === 'colaboradores-excedentes') {
          return modalColaboradoresExcedenteValorRemuneracao({
            listaColaboradores: data.details,
            onOk: () => {
              finalizeProcessing(request, true);
            },
            onCancel: () => {
              setLoadingModal(false);
              setShowProcessModal(false);
            },
            usuario: user,
          });
        }

        if (data?.type === 'total-liquido-invalido') {
          const providedNetTotal = data.details?.providedNetTotal ?? request.totalLiquido;
          const calculatedNetTotal = data.details?.calculatedNetTotal ?? calculateLiquidoTotal(cooperatorsRequest);
          try {
            await createMetric({
              key: 'payroll.total-liquido-invalido',
              source: 'apontamento-producao.processar',
              details: { providedNetTotal, calculatedNetTotal, payroll: payload.payroll },
            });
          } catch (e) {
            console.error(e);
          }

          return Modal.confirm({
            centered: true,
            title: 'Divergência no valor líquido',
            content: (
              <div>
                <p>O valor total difere do valor calculado dos itens.</p>
                <p>
                  Valor atual: <b>{moneyFormat(providedNetTotal)}</b>
                </p>
                <p>
                  Valor calculado dos itens: <b>{moneyFormat(calculatedNetTotal)}</b>
                </p>
                <p>Deseja prosseguir com o valor calculado dos itens e reenviar a requisição?</p>
              </div>
            ),
            okText: 'Sim, reenviar',
            cancelText: 'Não, cancelar',
            onOk: () => {
              const resendPayload = {
                ...request,
                calculatedNetTotal,
              };
              return finalizeProcessing(resendPayload, acceptedExceededCollaborators);
            },
            onCancel: () => {
              setLoadingModal(false);
              setShowProcessModal(false);
            },
          });
        }
      }
      setLoadingModal(false);
      setShowProcessModal(false);
      mostrarErro(err);
    }

    return true;
  };

  const onSave = async (showModal = true) => {
    try {
      const sendType = type === APONTAMENTO.tiposRequisicoes.adiantamento ? 'adiantamentos' : 'mensais';
      const calculationData = applySelectionRulesToCollaborators();

      await http.patch(`/apontamento/${payroll.id}/${sendType}`, calculationData);

      if (showModal) {
        Modal.success({
          title: 'Sucesso',
          content: 'Requisição salva com sucesso!',
        });
      }
    } catch (err) {
      mostrarErro(err);
    }
  };

  const onUpdate = async () => {
    try {
      const payrollCopy = parseToLegacyRequest(payroll);
      const sendModel = { requisicao: payrollCopy, parametrizacaoAntiga: parameterization };
      await http.post('/apontamento/atualizar', sendModel);
      Modal.success({
        title: 'Sucesso',
        content: <p>Requisição atualizada com sucesso!</p>,
      });

      await fetchPayroll(sendModel.requisicao.id);
    } catch (err) {
      mostrarErro(err);
    }
  };

  return {
    finalizarProcessamento: finalizeProcessing,
    onSalvar: onSave,
    onAtualizar: onUpdate,
  };
};
